export default __webpack_public_path__ + "static/media/banner_boomi.02d7af37.png";